import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useEvents } from '../../hooks/useEvents';
import { Block } from '../Blocks/Block';
import { LoadingSpinner } from '../LoadingSpinner';
import { EventItem } from './EventList';

export const EventsBlock: React.FC<{}> = (props) => {
    const { models } = useEvents();

    const { loading } = models;
    const eventLink = process.env.REACT_APP_EVENTLINK as string;

    return loading ? (
        <div>
            <LoadingSpinner />
        </div>
    ) : (
        <Row>
            {models.events?.map((event, index) => {
                return (
                    <Col xl={6}>
                        <div className="mb-3">
                            <EventItem event={event} />
                        </div>
                    </Col>
                );
            })}

            {models.events?.length === 0 && (
                <Block title={'Events'}>
                    <div
                        style={{
                            textAlign: 'center',
                            marginTop: '2em',
                            marginBottom: '2em',
                        }}
                    >
                        You do not have any booked events.
                        <div
                            style={{
                                marginTop: '2em',
                                marginBottom: '2em',
                            }}
                        >
                            <Button
                                target="_blank"
                                href={eventLink}
                                className="small"
                                variant="outline-primary"
                            >
                                Find CPD Events
                            </Button>
                        </div>
                    </div>
                </Block>
            )}
        </Row>
    );
};
